<template>
  <ls-table-layout>
    <div class="table-page-search-wrapper" slot="search">
      <a-form layout="inline" :labelCol="{ style: { width: '70px' } }">
        <a-row>
          <a-col :md="6" :sm="24">
            <a-form-item label="需求类型">
              <global-select
                @change="handleChange"
                :value.sync="queryParams.listDemandType"
                selectType="select"
                requestApi="/scp/scpSopShipmentForecast/listDemandType"
                :selectItem="{ value: 'realValue', label: 'label' }"
              />
            </a-form-item>
          </a-col>

          <a-col :md="6" :sm="24">
            <span class="table-page-search-submitButtons">
              <a-button @click="onSearch" type="primary" >查询</a-button>
              <a-button @click="resetQuery" class="ml8">重置</a-button>
            </span>
          </a-col>
        </a-row>
      </a-form>
    </div>
    <div class="table-page-operator-wrapper" slot="btn">
      <a-button @click="handleExport" type="primary" v-hasPermi="['mdm:mdmUomUnitsOfMeasure:export']">导出汇总 </a-button>
      <a-button @click="handleExport" type="primary" v-hasPermi="['mdm:mdmUomUnitsOfMeasure:export']">导出明细 </a-button>
    </div>
    <template v-slot:table>
      <div class="page-header-content">
        <a-spin :spinning="loading">

          <ls-api-table
            ref="dataTable"
            :columns="columns"
            :tableProps="tableProps"
            rowKey="id"
            :scroll="{ fixScreen: true }"
          >

            <template slot="demandDate" slot-scope="{ text }">
              <span>{{ text && $moment(text).format('YYYY-MM-DD') }}</span>
            </template>
          </ls-api-table>
        </a-spin>
      </div>
    </template>
  </ls-table-layout>
</template>

  <script>
  import { apilistShipmentForecastDetail } from '@/api/scp/shipmentForecast/shipmentForecastManagement'
  import { generateLsTableResData } from '@/utils/util.js';
  export default {
    // eslint-disable-next-line
    name: 'monthsDetail',
    components: {

    },
    data () {
      return {
        loading: false,
        filterKey: '',
        // 表格配置1
        tableProps: {
          requestApi: generateLsTableResData(apilistShipmentForecastDetail, true),
          pageCurrent: true
        },
        // 控制搜索展开
        advanced: true,
        // 查询参数
        queryParams: {
            itemId: undefined,
            month: undefined,
            name: undefined,
            version: undefined,
            listDemandType: '',
            demandDepartment: ''
        },
        // 表格多选
        selectedRowKeys: [],
        selectedRows: [],
        // 状态快码
        statusOptions: [
          {
            dictLabel: "有效",
            dictValue: "Y"
          },
          {
            dictLabel: "无效",
            dictValue: "N"
          }
        ],
        baseUomFlagOptions: [
          {
            dictLabel: "是",
            dictValue: "Y"
          },
          {
            dictLabel: "否",
            dictValue: "N"
          }
        ],
        // 表格字段
        columns: [
         {
            title: '事业部',
            dataIndex: 'demandDepartment',
            align: 'center',
            ellipsis: true,
            width: 150
          },
          {
            title: '物料编码',
            dataIndex: 'itemCode',
            align: 'center',
            ellipsis: true,
            width: 150
          },
          {
            title: '规格描述',
            dataIndex: 'specification',
            ellipsis: true,
            align: 'center'
          },
          {
            title: '需求数量',
            dataIndex: 'demandQuantity',
            ellipsis: true,
            align: 'center'
          },
          {
            title: '需求日期',
            dataIndex: 'demandDate',
            scopedSlots: { customRender: 'demandDate' },
            ellipsis: true,
            align: 'center'
          },
          {
            title: '需求期间',
            dataIndex: 'demandPeriod',
            ellipsis: true,
            scopedSlots: { customRender: 'status' },
            align: 'center'
          },
          {
            title: '需求类型',
            dataIndex: 'demandType',
            ellipsis: true,
            align: 'center'
          }
        ],
        uomClassOptions: [],
        unitOfMeasureList: [],
        tableAllData: [],
        tableFilterData: []
      }
    },
    created () {
        this.queryParams.itemId = this.$route.params.id;
        this.queryParams.month = this.$route.params.month;
        this.queryParams.name = this.$route.params.name;
        this.queryParams.version = this.$route.params.version;
        this.queryParams.demandDepartment = this.$route.params.demandDepartment;
        this.getlistShipmentForecastDetail()
    },
    mounted () {
    },
    methods: {
        handleChange (val, selectList) {
            const filteredItem = selectList.filter(item => item.realValue === val);
            this.filterKey = filteredItem[0].label;
        },
      uomClassOnChange () {
        this.getUnitOfMeasureList()
      },
      // 导入导出excel
      /** 导出按钮操作 */
      handleExport () {
        this.download('mdm/mdmUomUnitsOfMeasure/export', {
          ...this.queryParams
        }, `单位_${new Date().getTime()}.xlsx`)
      },
      getlistShipmentForecastDetail () {
        this.loading = true
        apilistShipmentForecastDetail(this.queryParams).then(res => {
          this.loading = false
          if (res.code === 200 && res.data && res.data.length > 0) {
            this.tableAllData = res.data;
            this.tableFilterData = this.tableAllData
            this.$refs.dataTable.myDataSource = this.tableFilterData
          }
        }).catch((e) => { this.loading = false })
      },
      // 表单搜索
      onSearch () {
        // this.$refs.dataTable.searchParams = this.queryParams;
        // this.$refs.dataTable.getData();
            if (this.filterKey) {
                const filteredTableData = this.tableAllData.filter(item => item.demandType === this.filterKey);
            this.tableFilterData = filteredTableData
            this.$refs.dataTable.myDataSource = this.tableFilterData
            } else {
                this.$refs.dataTable.myDataSource = this.tableAllData
            }
      },
      /** 重置按钮操作 */
      resetQuery () {
        this.queryParams.listDemandType = ''
        this.filterKey = ''
        this.$refs.dataTable.myDataSource = this.tableAllData
      },
      // 搜索框展开、收起
      toggleAdvanced () {
        this.advanced = !this.advanced
      }
    }
  }
  </script>

  <style scoped lang="less">
  .ml10{
    margin-left: 10px;
  }
  </style>
